var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",on:{"click":function($event){return _vm.openContactFormModal()}}},[_vm._v("\n    Kontakt\n")])}
var staticRenderFns = []

export { render, staticRenderFns }